import { Slider } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IHoursProps {
    hours: number
    onChange: (hours: number) => void
}
const Hours = ({hours, ...props}: IHoursProps): JSX.Element => { 
    const onChange = (h: number ) => {  
        props.onChange( h )
    }
    return <div className="time-container" >
        <div className="small letter-spacing-2">
            {__("Hours")}
        </div>
        <Slider
            min={ 0 }
            max={ 24 }
            stepSize={ 1 }
            labelStepSize={ 2 }
            value={ hours }
            onChange={ onChange }
            className="my-2 slider-width"
        />
    </div>
}
export default Hours